import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

import { isAuthenticated } from "./services/auth";

import Login from "./pages/Login";
import Menu from "./pages/Menu";
import Clients from "./pages/Client/Index";
import Users from "./pages/User/Index";
import CCD from "./pages/CCD/Index";
import Mail from "./pages/CCD/Mail/Index";
import AdminClients from "./pages/Administration/Client/Index";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        )
    }
  />
);

const Routes = () => (
  <Router>
    <Switch>
      <Route exact path="/" component={Login} />
      <PrivateRoute exact path="/cliente" component={Clients} />
      <PrivateRoute path="/menu/" component={Menu} />
      <PrivateRoute path="/usuarios" component={Users} />
      <PrivateRoute exact path="/ccd" component={CCD} />
      <PrivateRoute path="/ccd/mail" component={Mail} />
      <PrivateRoute path="/administracao/cliente" component={AdminClients} />
      <Route path="*" component={() => <h1 style={{ textAlign: 'center' }}>Page not found</h1>} />
    </Switch>
  </Router>
);

export default Routes;